import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { PoseGroup } from 'react-pose';
import { Error as ErrorStyled } from './Error.style';

const propTypes = {
  name: PropTypes.string
};

const defaultProps = {
  name: null
};

const Error = ({ name }) =>
  name && (
    <Field
      name={name}
      key={`error_${name}`}
      subscription={{
        touched: true,
        error: true,
        submitError: true,
        submitFailed: true,
        dirtySinceLastSubmit: true
      }}
      render={({
        meta: { touched, error, submitError, dirtySinceLastSubmit }
      }) => {
        const errorMessage =
          (error || (submitError && !dirtySinceLastSubmit)) && touched ? (
            <ErrorStyled key="error">{error || submitError}</ErrorStyled>
          ) : null;

        return (
          <PoseGroup preEnterPose="preEnter" flipMove={false}>
            {errorMessage}
          </PoseGroup>
        );
      }}
    />
  );

Error.propTypes = propTypes;
Error.defaultProps = defaultProps;

export default Error;
